import React from 'react';
import Link from 'gatsby-link';
import styled from 'styled-components';
import bg from '../../assets/img/footerBG.jpg';
import {P2} from "../Kit/Kit";
import emailImg from '../../assets/img/email.svg'
import gpsImg from '../../assets/img/gps.svg'
import phoneImg from '../../assets/img/phone.svg'

const Container = styled.footer`
  background: url("${bg}") no-repeat 100% 100%;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(4, 1fr);
  grid-row-gap: 50px;
  padding: 50px 60px 0;
  justify-content: center;
  
  @media(min-width: 768px) {
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(2, auto);
    padding: 210px 60px 150px ;
    grid-row-gap: 100px;
  }
  
  @media(min-width: 1200px){
      grid-template-columns: repeat(3, 450px);
  }
`;

const IconContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(3, auto);
  grid-row-gap: 16px;
  justify-items: center;
`;

const Icon = styled.img`
  width: 49px;
  height: 49px;
`;

const Terms = P2.extend`
  @media(min-width: 768px){
    grid-column: 1/4;
  }
  
  @media(min-width: 1200px) {
    font-size: 18px;
  } 
`;

const ContactTitle = styled.h1`
  font-family: Cabin-Bold, sans-serif;
  font-size: 22px;
  color: #004a87;
  text-align: center;
  
  @media(min-width: 1200px) {
     font-size: 20px;
  }
`;

const Links = P2.withComponent('a');

const Footer = (props) => {
    const {phone, location, email} = props.footer[0].node.acf;
    return (
      <Container>
          <IconContainer>
              <Icon src={phoneImg} alt="phone"/>
              <ContactTitle>Phone</ContactTitle>
              <Links title="Call H & N Group" href={`tel: +1${phone}`}>{phone}</Links>
          </IconContainer>
          <IconContainer>
              <Icon src={gpsImg} alt="gps"/>
              <ContactTitle>Location</ContactTitle>
              <Links
                title="Visit the H & N Group Los Angeles, CA Location"
                href={`https://maps.google.com/maps?q=${location}`}
                target="_blank">{location}</Links>
          </IconContainer>
          <IconContainer>
              <Icon src={emailImg} alt="email"/>
              <ContactTitle>Email</ContactTitle>
              <Links title="Email H & N Group" href={`mailto:${email}`}>{email}</Links>
          </IconContainer>
          <Terms>H & N Group &copy; 2018 All Rights Reserved <Link to="/terms">Terms of Use</Link> and <Link
            to="/privacy-policy">Privacy Policy</Link></Terms>
      </Container>
    );
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js